(()=>{
function init(scope=document){
 scope.querySelectorAll('[data-mm-product]').forEach(root=>{
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  root.querySelectorAll('[data-mm-thumb]').forEach(button=>button.addEventListener('click',()=>{
   root.querySelectorAll('[data-mm-slide]').forEach(slide=>slide.hidden=slide.dataset.mmSlide!==button.dataset.mmThumb);
   root.querySelectorAll('[data-mm-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  }));
  root.querySelectorAll('[data-mm-fit-link]').forEach(fit=>fit.addEventListener('click',()=>{const details=root.querySelector(fit.getAttribute('href'));if(details)details.open=true}));
  const form=root.querySelector('.mm-form'),singleSize=root.querySelector('[data-mm-single-size]'),dataNode=root.querySelector('[data-mm-variants]');
  if(!form||!singleSize||!dataNode)return;
  let data;try{data=JSON.parse(dataNode.textContent)}catch{return}
  const button=form.querySelector('.mm-buy'),offers=root.querySelectorAll('[data-mm-offer]'),bundleSizes=[...root.querySelectorAll('[data-mm-bundle-size]')],variantInput=form.querySelector('[data-mm-cart-variant]');
  if(!button||!variantInput||bundleSizes.length!==3)return;
  const match=(kind,values)=>(data[kind]||[]).find(v=>v.options.length===values.length&&v.options.every((value,i)=>value===values[i]));
  const update=()=>{
   let chosen;
   offers.forEach(offer=>{
    const kind=offer.dataset.mmOffer,values=kind==='single'?[singleSize.value]:bundleSizes.map(select=>select.value),variant=match(kind,values);
    const panel=root.querySelector('[data-mm-panel="'+kind+'"]');
    panel.hidden=!offer.checked;
    panel.querySelectorAll('select').forEach(select=>select.disabled=!offer.checked);
    offer.setAttribute('aria-expanded',String(offer.checked));
    root.querySelector('[data-mm-price="'+kind+'"]').textContent=variant?variant.formatted:button.dataset.mmUnavailable;
    if(kind==='single')root.querySelector('[data-mm-reference]').textContent=variant?variant.two:'—';
    if(offer.checked)chosen=variant;
   });
   const ready=!!chosen&&chosen.available&&chosen.price>0&&data.enabled;
   variantInput.value=ready?String(chosen.id):'';
   variantInput.disabled=!ready;
   button.disabled=!ready;
   button.querySelector('.mm-buy-label').textContent=ready?button.dataset.mmAdd+' — '+chosen.formatted:button.dataset.mmUnavailable;
   form.querySelector('[name="quantity"]').value='1';
  };
  offers.forEach(offer=>offer.addEventListener('change',update));
  [singleSize,...bundleSizes].forEach(select=>select.addEventListener('change',update));
  root.querySelectorAll('.mm-native-pack').forEach(card=>card.addEventListener('click',event=>{
   if(event.target.closest('input,select,option,label'))return;
   const radio=card.querySelector('[data-mm-offer]');radio.checked=true;update();
  }));
  form.addEventListener('submit',event=>{update();if(button.disabled)event.preventDefault()});
  update();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
document.addEventListener('shopify:section:load',event=>init(event.target));
})();
